<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  export let href: string = '';
  export let target: string = '_blank';
  export let fontSize: string = '1.2em';
  export let lineHeight: string = '22px';
  export let letterSpacing: string = '0px';
  export let fontWeight: string = '400';
  export let width: string = '100%';

  const dispatch = createEventDispatcher();

  const style = `
    font-size: ${fontSize};
    line-height: ${lineHeight};
    letter-spacing: ${letterSpacing};
    font-weight: ${fontWeight};
    width: ${width};
    ${$$props.style}
  `;

  function onClick() {
    dispatch('click');
  }
</script>

{#if href}
  <a class={$$props.class} {href} {target} {style}><slot /></a>
{:else}
  <a class={$$props.class} href="javascript:;" on:click={onClick} {style}
    ><slot /></a
  >
{/if}

<style lang="scss">
  a {
    color: var(--twism-theme-link);
    text-decoration: underline;
    display: inline-block;
    text-align: center;
    transition: color 0.2s ease-in-out;

    @media screen and (min-width: 768px) {
      &:hover {
        color: var(--twism-theme-linkHover);
      }
    }
  }
</style>
